module.exports = __webpack_public_path__ + "img/go_right.ff831b4c.svg";